import { ROLES } from "constants/user";


export const getDashboard = ({
  role = ROLES.PERSONAL_USER,
  uid,
  orgs
}) => {
  // console.log('route uid = ', uid);
  // console.log('route orgs = ', orgs);

  switch (role) {
    case ROLES.SUPER_ADMIN:
      return {
        pathname: "/admin/dashboardForSuperAdmin"
      };
    case ROLES.ASSOCIATION_ADMIN:
      return {
        pathname: "/admin/dashboardForAssociation"
      }
    case ROLES.ORG_ADMIN:
    case ROLES.ORG_COUNSELOR:
      return {
        pathname: "/admin/dashboardForOrg",
        state: { org_id: orgs && orgs.length > 0 ? orgs[0] : null }
      }
    case ROLES.PERSONAL_USER:
      return {
        pathname: "/admin/dashboardForPerson",
        state: { uid, org_id: orgs && orgs.length > 0 ? orgs[0] : null }
      }
    default:
      return {
        pathname: "/admin/dashboardForPerson",

      }
  }
}